// extracted by mini-css-extract-plugin
export default {"row":"AdminCrudRow_row__M2pS-"};